import React from 'react';
import styled, { keyframes } from 'styled-components';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { selectUserData } from '../selectors';
import { compose, withHandlers } from 'recompose';
import { declOfNum } from '../../../lib/decl-of-num';
import { Button } from '../../../ui/atoms';
import { SidebarButton } from '../../../ui/molecules';
import { getRemainingTime } from '../../../lib/getRemainingTime';
import { RenderIfConnected } from './render-if';
import i18next from 'i18next';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { Analytics } from '../../../analytics';

const mapStateToProps = (state) => ({
  isStandalone: state.root.isStandalone,
  tariff: selectUserData(state).tariff,
  expire: getRemainingTime(selectUserData(state).tariff.expire),
  rawExpire: selectUserData(state).tariff.expire,
  locale: state.common.locale,
});

const enchance = compose(
  connect(mapStateToProps),
  withHandlers({
    handleClick: ({ tariff, isStandalone, locale, dispatch }) => () => {
      if (!tariff.alias) {
        return;
      }

      if (tariff.alias !== 'start') {
        Analytics.clickTariffChange({ locale, oldTariff: tariff.alias, newTariff: tariff.alias });
      }

      if (tariff.alias === 'start') {
        if (isStandalone) {
          window.top.postMessage(
            {
              cabinet: true,
              type: 'OPEN_STORE',
              data: {
                initialScreen: 'pricing',
              },
            },
            '*'
          );
        } else {
          window.uiStore.open({
            initialScreen: 'pricing',
          });
        }
      } else {
        if (isStandalone) {
          window.top.postMessage(
            {
              cabinet: true,
              type: 'OPEN_STORE',
              data: {
                cartTariff: tariff.alias,
                initialScreen: 'cart',
              },
            },
            '*'
          );
        } else {
          window.uiStore.open({
            cartTariff: tariff.alias,
          });
        }
      }
    },
  })
);

const TariffButtonView = ({ tariff, open, rawExpire, expire, to, handleClick }) => {
  if (open) {
    return (
      <RenderIfConnected cond={tariff.name} noText>
        <ContainerOpen>
          <Border>
            <Label>{i18next.t('cabinet.misc.tariff')}</Label>
            <NameOpen>
              <RenderIfConnected cond={tariff.name || rawExpire === -1} noText>
                {rawExpire >= 0 ? tariff.name : i18next.t('cabinet.misc.blocked')}
              </RenderIfConnected>
            </NameOpen>
            <Extend onClick={handleClick}>
              {tariff.alias === 'start' ? i18next.t('cabinet.tariff.upgrade') : i18next.t('cabinet.tariff.extend')}
            </Extend>
          </Border>
          <RenderIfConnected cond={expire > 0} noText>
            <RemainingTime>
              {declOfNum(expire, [
                i18next.t('cabinet.misc.left.plural.1'),
                i18next.t('cabinet.misc.left.plural.5'),
                i18next.t('cabinet.misc.left.plural.5'),
              ])}{' '}
              {expire}{' '}
              {declOfNum(expire, [
                i18next.t('cabinet.misc.day.plural.1'),
                i18next.t('cabinet.misc.day.plural.2'),
                i18next.t('cabinet.misc.day.plural.5'),
              ])}
            </RemainingTime>
          </RenderIfConnected>
        </ContainerOpen>
      </RenderIfConnected>
    );
  } else {
    return (
      <SidebarButton
        to={to}
        render={
          <Container>
            {i18next.t('cabinet.misc.tariff')}: <Name>{tariff.alias === 'businessvr' ? 'VR' : tariff.name}</Name>
          </Container>
        }
      />
    );
  }
};

export const TariffButton = enchance(TariffButtonView);

const ContainerOpen = styled.div`
  margin-top: 20px;
  animation: ${show} 0.2s forwards;
`;
const Border = styled.div`
  position: relative;
  width: 176px;
  height: 80px;
  margin: auto;
  border-radius: 4px;
  border: solid 1px ${Colors.whisper};
  background-color: ${Colors.white};
`;
const Label = styled.div`
  position: absolute;
  top: -7px;
  left: 10px;
  font-size: 12px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  background-color: ${Colors.white};
  padding: 0 4px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;
const Extend = styled(Button)`
  height: 40px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  font-size: 14px;
`;
const RemainingTime = styled.div`
  font-size: 12px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  margin-top: 8px;
`;
const Container = styled.div`
  font-size: 12px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  height: 44px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: center;
`;
const Name = styled.div`
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
`;
const NameOpen = styled(Name)`
  line-height: 40px;
  height: 40px;
  text-align: left;
  padding-left: 15px;
`;
const show = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;
